import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { SERVICES } from "@/mock";

const ServicesShowcase = () => {
  return (
    <section
      data-testid="services-showcase"
      className="py-24 lg:py-32 bg-brand-bg"
    >
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12">
        {/* Header */}
        <div className="grid lg:grid-cols-12 gap-8 mb-16 items-end">
          <div className="lg:col-span-7">
            <p className="text-xs font-bold uppercase tracking-[0.24em] text-brand-cta mb-4 flex items-center gap-3">
              <span className="block w-10 h-px bg-brand-cta" />
              What we do
            </p>
            <h2 className="font-heading text-4xl sm:text-5xl lg:text-6xl font-black tracking-tighter text-brand-ink leading-[0.95]">
              Six specialties.<br />
              <span className="italic font-light">One trusted crew.</span>
            </h2>
          </div>
          <div className="lg:col-span-5">
            <p className="text-base lg:text-lg text-brand-inkSoft leading-relaxed">
              We don't subcontract the craft. From demolition to final caulk
              line, the same hands that estimated your job are the ones doing
              the work.
            </p>
          </div>
        </div>

        {/* Bento Grid */}
        <div className="grid grid-cols-1 md:grid-cols-12 gap-4 lg:gap-6">
          {SERVICES.map((service, i) => {
            // Asymmetric layout: alternate spans
            const spanMap = [
              "md:col-span-7",
              "md:col-span-5",
              "md:col-span-5",
              "md:col-span-7",
              "md:col-span-7",
              "md:col-span-5",
            ];
            return (
              <Link
                key={service.slug}
                to="/services"
                data-testid={`service-card-${service.slug}`}
                className={`${spanMap[i]} group relative overflow-hidden bg-brand-ink aspect-[4/3] md:aspect-auto md:h-[420px] block`}
              >
                <img
                  src={service.image}
                  alt={service.title}
                  className="absolute inset-0 w-full h-full object-cover opacity-90 group-hover:opacity-100 transition-all duration-700 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-brand-ink via-brand-ink/40 to-transparent" />

                <div className="absolute inset-0 p-8 lg:p-10 flex flex-col justify-between">
                  <div className="flex items-start justify-between">
                    <span className="text-[10px] font-bold uppercase tracking-[0.2em] text-white/70">
                      0{i + 1} / 0{SERVICES.length}
                    </span>
                    <span className="w-10 h-10 border border-white/30 flex items-center justify-center group-hover:border-brand-cta group-hover:bg-brand-cta transition-colors">
                      <ArrowUpRight
                        className="w-4 h-4 text-white"
                        strokeWidth={2}
                      />
                    </span>
                  </div>

                  <div>
                    <h3 className="font-heading text-2xl lg:text-3xl font-bold tracking-tight text-white mb-3">
                      {service.title}
                    </h3>
                    <p className="text-sm text-white/80 max-w-md leading-relaxed">
                      {service.short}
                    </p>
                  </div>
                </div>
              </Link>
            );
          })}
        </div>

        <div className="mt-12 flex justify-center">
          <Link
            to="/services"
            data-testid="services-view-all"
            className="inline-flex items-center gap-3 text-sm font-bold uppercase tracking-[0.16em] text-brand-ink border-b border-brand-ink hover:text-brand-cta hover:border-brand-cta pb-1 transition-colors"
          >
            View all services
            <ArrowUpRight className="w-4 h-4" strokeWidth={2} />
          </Link>
        </div>
      </div>
    </section>
  );
};

export default ServicesShowcase;
